<section class="we-believe section section__bg-gradient-parent" xmlns="http://www.w3.org/1999/html">
  <div class="we-believe__gradient section__bg-gradient" aria-hidden="true"></div>

  <div class="we-believe__inner container">
    <div class="we-believe__hero">
      <div class="we-believe__intro">
        <h1 class="we-believe__headline heading-display-small">We Believe</h1>
        <p class="we-believe__lead subheading">
          The most dangerous thing in the age of machines is not the machine. It is that while being
          enamored by the speed of output, we started accepting a new form of being creative which
          has to do with being a slot machine operator. Buy credit, write prompt incantations, push
          the button and hope the algorithm does not hallucinate too much.
        </p>
      </div>

      <figure class="we-believe__banner">
        <img
          class="we-believe__banner-image"
          fill
          priority
          ngSrc="/assets/origin/founder-banner.jpg"
          alt="Pinar Seyhan Demirdag"
        />
        <figcaption class="we-believe__caption type-body-b3 type-md-caption-c3">
          Pinar Seyhan Demirdag, Founder and CEO of EVRN
        </figcaption>
      </figure>
    </div>

    <div class="we-believe__conviction">
      <h2 class="we-believe__conviction-title title">Our Conviction</h2>

      <div class="we-believe__conviction-copy subheading" appScrollReveal>
        @for (paragraph of convictionParagraphs; track $index) {
          <p appScrollRevealItem>{{ paragraph }}</p>

          @if ($index === 0 || $index === 1) {
            <br />
          }
        }
      </div>
    </div>
  </div>
</section>

<section class="we-believe-banner section">
  <div class="we-believe-banner__inner container">
    <figure class="we-believe__banner we-believe__banner--cuebric">
      <img
        class="we-believe__banner-image"
        fill
        ngSrc="/assets/origin/cuebric-banner.png"
        alt="Cuebric used on set"
      />
      <figcaption class="we-believe__caption type-body-b3 type-md-caption-c3">
        Cuebric used on set, 2024 ROE x Disguise Studios
      </figcaption>
    </figure>
  </div>
</section>
